import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import axios from "axios";
import API from "../helpers/api";
import swal from "sweetalert";

let currentUser = JSON.parse(localStorage.getItem("currentUser"));
class newTechSuperintendent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      techSuperintendentInfo: {
        userRole: "superintendent",
        userName: "",
        email: "",
        telephone: "",
        createdBy: currentUser.email,
      },
      index: 0,
      techSuperintendentArray: [],
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.updateTechSuperintendent = this.updateTechSuperintendent.bind(this);
    this.addTechSuperintendent = this.addTechSuperintendent.bind(this);
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const {
      techSuperintendentList,
      techSuperintendentDetail,
      dispatch,
    } = nextProps;
    if (techSuperintendentDetail) {
      prevState.techSuperintendentInfo.userName =
        techSuperintendentDetail.userName;
      prevState.techSuperintendentInfo.email = techSuperintendentDetail.email;
      prevState.techSuperintendentInfo.telephone =
        techSuperintendentDetail.telephone;
      prevState.index = techSuperintendentList.findIndex(
        (x) => x.email === techSuperintendentDetail.email
      );
      dispatch({ type: "GetTechSuperintendentDetails", data: null });
    }
    if (techSuperintendentList) {
      prevState.techSuperintendentArray = techSuperintendentList;
    }
  }

  handleInputChange(e) {
    let nodeName = e.target.name;
    this.state.techSuperintendentInfo[nodeName] = e.target.value;
    this.setState({});
  }

  addTechSuperintendent() {
    let emailregex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const {
      dispatch,
      fleetManagerList,
      techSuperintendentList,
      techExecutiveList,
    } = this.props;
    if (this.state.techSuperintendentInfo.email !== "") {
      if (emailregex.test(this.state.techSuperintendentInfo.email)) {
        const enteredEmail = this.state.techSuperintendentInfo.email.trim();
        const normalizedEmail = enteredEmail.toLowerCase();
        const emailExistsInClient =
          (fleetManagerList || []).some(
            (x) => x?.email?.trim().toLowerCase() === normalizedEmail
          ) ||
          (techSuperintendentList || []).some(
            (x) => x?.email?.trim().toLowerCase() === normalizedEmail
          ) ||
          (techExecutiveList || []).some(
            (x) => x?.email?.trim().toLowerCase() === normalizedEmail
          );

        if (emailExistsInClient) {
          swal(
            "Error!",
            `User with email ${enteredEmail} already exists in this client.`,
            "warning"
          );
          return;
        }

        let url2 = `${API.userExist}?Mail=${this.state.techSuperintendentInfo.email}`;
        axios
          .get(url2, {
            headers: {
              key: currentUser.accessToken,
            },
          })
          .then((response) => {
            if (response.data === true) {
              this.state.techSuperintendentArray.push(
                this.state.techSuperintendentInfo
              );
              this.props.dispatch({
                type: "GetTechSuperintendentlist",
                data: this.state.techSuperintendentArray,
              });
              this.hideSidePanel();
            } else if (response.data === false) {
              swal(
                "Error!",
                "User already exist. Please change the email",
                "warning"
              );
              this.state.techSuperintendentInfo.email = "";
              this.setState({});
            }
            dispatch({
              type: "getUserExistListSuccess",
              data: response.data,
            });
          })
          .catch((error) => {
            dispatch({
              type: "getUserExistListFailure",
              data: "error",
            });
          });
      }
      else {
        swal("Error!", "Invalid email format", "warning");
      }
    } else {
      swal("Error!", "Email is mandatory", "warning");
    }
  }

  updateTechSuperintendent() {
    let emailregex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const { techSuperintendentInfo, index } = this.state;
    const {
      dispatch,
      fleetManagerList,
      techSuperintendentList,
      techExecutiveList,
    } = this.props;
    if (this.state.techSuperintendentInfo.email !== "") {
      if (emailregex.test(this.state.techSuperintendentInfo.email)) {
        const enteredEmail = this.state.techSuperintendentInfo.email.trim();
        const normalizedEmail = enteredEmail.toLowerCase();
        const emailExistsInClient =
          (fleetManagerList || []).some(
            (x) => x?.email?.trim().toLowerCase() === normalizedEmail
          ) ||
          (techSuperintendentList || []).some(
            (x, i) =>
              i !== index &&
              x?.email?.trim().toLowerCase() === normalizedEmail
          ) ||
          (techExecutiveList || []).some(
            (x) => x?.email?.trim().toLowerCase() === normalizedEmail
          );

        if (emailExistsInClient) {
          swal(
            "Error!",
            `User with email ${enteredEmail} already exists in this client.`,
            "warning"
          );
          return;
        }

        let url2 = `${API.userExist}?Mail=${this.state.techSuperintendentInfo.email}`;
        axios
          .get(url2, {
            headers: {
              key: currentUser.accessToken,
            },
          })
          .then((response) => {
            if (response.data === true) {
              this.state.techSuperintendentArray[index] = techSuperintendentInfo;
              this.setState({});
              this.props.dispatch({
                type: "GetTechSuperintendentlist",
                data: this.state.techSuperintendentArray,
              });
              this.hideSidePanel();
            } else if (response.data === false) {
              swal(
                "Error!",
                "User already exists.",
                "warning"
              );
              this.state.techSuperintendentInfo.email = "";
              this.setState({});
            }
            dispatch({
              type: "getUserExistListSuccess",
              data: response.data,
            });
          })
          .catch((error) => {
            dispatch({
              type: "getUserExistListFailure",
              data: "error",
            });
          });
      }
      else {
        swal("Error!", "Invalid email format", "warning");
      }
    } else {
      swal("Error!", "Email is mandatory", "warning");
    }
  }

  hideSidePanel() {
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.props.history.push("/Home/Management/ClientAdd");
  }

  render() {
    const { EditUser } = this.props;
    return (
      <div className="full-height">
        <div className="resource-list-auth-date row pt-3 ">
          <div className="w-100">
            <div className="panel-box search-filter-box">
              <button
                className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                onClick={() => this.hideSidePanel()}
              >
                <div style={{ position: 'relative' }}>
                  <span className="backarr">&larr;</span> <span style={{ marginLeft: "18px" }}>Return</span>
                </div>
              </button>
              <div
                className="card mt-2 MM-card-header"
                style={{ backgroundColor: "white" }}
              >
                <div
                  className="card-body"
                  style={{
                    padding: "0rem",
                    backgroundColor: "#1a3464",
                    color: "white",
                  }}
                >
                  <h5
                    className="card-title ml-4 mt-2"
                    style={{ color: "092a51" }}
                  >
                    Marine Superintendents
                  </h5>
                </div>
              </div>
              <div className="row search-filter-box">
                <div className="col-lg-6">
                  <label className="form-label">Name</label>
                  <br></br>
                  <input
                    type="text"
                    className="form-control"
                    name="userName"
                    value={this.state.techSuperintendentInfo.userName}
                    placeholder="Name"
                    onChange={(e) => this.handleInputChange(e)}
                  ></input>
                </div>
                <div className="col-lg-6">
                  <label className="form-label">Email<span className="mandatory">*</span></label>
                  <br></br>
                  <input
                    type="email"
                    className="form-control"
                    name="email"
                    value={this.state.techSuperintendentInfo.email}
                    placeholder="Email"
                    onChange={(e) => this.handleInputChange(e)}
                  ></input>
                </div>
                <div className="col-lg-6">
                  <label className="form-label">Phone</label>
                  <br></br>
                  <input
                    type="text"
                    className="form-control"
                    name="telephone"
                    value={this.state.techSuperintendentInfo.telephone}
                    placeholder="Phone"
                    onChange={(e) => this.handleInputChange(e)}
                  ></input>
                </div>
                <div className="col-lg-12 mt-2 search-filter-box">
                  <div className="search-btn-col" style={{ textAlign: "end" }}>
                    {!EditUser ? (
                      <button
                        className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                        type="submit"
                        onClick={() => this.addTechSuperintendent()}
                      >
                        {" "}
                        Add{" "}
                      </button>
                    ) : (
                      <button
                        className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                        type="submit"
                        onClick={() => this.updateTechSuperintendent()}
                      >
                        {" "}
                        Update{" "}
                      </button>
                    )}
                    <button
                      className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                      type="button"
                      onClick={() => this.hideSidePanel()}
                    >
                      {" "}
                      Cancel{" "}
                    </button>
                  </div>
                </div>
              </div>
              {/* <div className="row">
                <div className="col-lg-12 search-filter-box">
                  <div className="search-btn-col" style={{ textAlign: "end" }}>
                    {!EditUser ? (
                      <button
                        className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                        type="submit"
                        onClick={() => this.addTechSuperintendent()}
                      >
                        {" "}
                        Add{" "}
                      </button>
                    ) : (
                      <button
                        className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                        type="submit"
                        onClick={() => this.updateTechSuperintendent()}
                      >
                        {" "}
                        Update{" "}
                      </button>
                    )}
                    <button
                      className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                      type="button"
                      onClick={() => this.hideSidePanel()}
                    >
                      {" "}
                      Cancel{" "}
                    </button>
                  </div>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
function mapStateToProps(state) {
  return {
    fleetManagerList: state.MasterScreenReducer.fleetManagerlist,
    techSuperintendentList: state.MasterScreenReducer.TechSuperintendentlist,
    techExecutiveList: state.MasterScreenReducer.TechExecutivelist,
    techSuperintendentDetail:
      state.MasterScreenReducer.TechSuperintendentDetail,
    EditUser: state.MasterScreenReducer.EditUser,
  };
}
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(newTechSuperintendent)
);
